import React, { Component } from 'react';
import i18n from '@i18next/i18n';
import styles from '../index.css';
import { tdw } from '@src/slide/infrastructure/module/dependent/report/offline-data-report/tdw-report';
import {
    TDWActionType,
    TDWModuleType,
    TDWOperationType,
} from '@src/slide/infrastructure/module/dependent/report/offline-data-report/constant';
import { INSERT_SLIDE_ORIGIN_TYPE } from '@src/js/constant';
import { TENANT_CONFIG } from '@src/slide/infrastructure/module/dependent/config/tob/constant';

interface IProps {
    onOnlineClick: () => void;
    handleClickCB: () => void;
}

export default class TemplateImportMenu extends Component<IProps> {
    public constructor(p: IProps) {
        super(p);
    }

    public render() {
        return <div className={styles.importMenu}>
            <div onClick={this.onLocalClick} className={styles.importItem}>
                <span>{i18n.t('从本地文档')}</span>
            </div>
            <div onClick={this.onOnlineClick} className={styles.importItem}>
                {/* eslint-disable @tencent/i18next/no-literal-string */}
                <span>{TENANT_CONFIG.TENANT_DOC_NAME ? `从${TENANT_CONFIG.TENANT_DOC_NAME}` : i18n.t('从腾讯文档')}</span>
            </div>
        </div>;
    }

    private onLocalClick = () => {
        document.getElementById('import-slide-input')?.click();
        this.props.handleClickCB?.();
        tdw({
            opername: TDWOperationType.DOC_PPT,
            module: TDWModuleType.INSERT_SLIDE_ENTRY,
            action: TDWActionType.INSERT_SLIDE_ENTRY_LOCAL,
            ver5: INSERT_SLIDE_ORIGIN_TYPE.LEFT_TOP,
        });
    };

    private onOnlineClick = () => {
        this.props.onOnlineClick();
        this.props.handleClickCB?.();
        tdw({
            opername: TDWOperationType.DOC_PPT,
            module: TDWModuleType.INSERT_SLIDE_ENTRY,
            action: TDWActionType.INSERT_SLIDE_ENTRY_ONLINE,
            ver5: INSERT_SLIDE_ORIGIN_TYPE.LEFT_TOP,
        });
    };
}
